import { css } from '../../../styles/theme';

export const StylesDS = css`
    .linkButton {
        color: ${({ theme }) => theme.colors.black};
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
            border: none;
        }
    }
`;
